export default __webpack_public_path__ + "static/media/trackingProducts1.c880f105.jpg";